import orderBy from 'lodash/orderBy'
import { FC } from 'react'

import { GuestReadinessStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { parseLabel } from '@new/domains/operations/utils/parseLabel'

interface GuestReadinessStatusesFilterProps extends FiltersProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const options = orderBy(
  Object.values(GuestReadinessStatus).map(recordType => ({
    value: recordType,
    label: parseLabel(recordType),
    hasFullWidth: true,
  })),
  'label',
)

export const GuestReadinessStatusesFilter: FC<GuestReadinessStatusesFilterProps> = props => {
  return <CheckboxBasedFilter options={options} {...props} />
}
